const defaultFormatterOptions = {
  style: "percent",
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
}

const formatter = new Intl.NumberFormat("en-US", defaultFormatterOptions)

export const formatPercent = function (value, options) {
  if (value == null) {
    return null
  }

  if (typeof value === "string") {
    value = parseFloat(value)
    if (isNaN(value)) {
      value = 0
    }
  }

  if (options) {
    const formatterOptions = Object.assign({}, defaultFormatterOptions, options)
    const customFormatter = new Intl.NumberFormat("en-US", formatterOptions)
    return customFormatter.format(value)
  } else {
    return formatter.format(value)
  }
}

export default {
  formatPercent,
}
